<div (click)="closeDialog()" class="close-button"></div>

<div [style.backgroundColor]="dialogData.brandColor" class="brand-logo-container"></div>

<div class="scrollable">
  <div [innerHTML]="getSvgImage(dialogData.inline_svg)" class="status-image"></div>
  <div *ngIf="dialogData.status === constants.DONATION_STATUS_SUCCEEDED" [style.color]="dialogData.brandColor"
       class="status-heading">{{ "BRAND_POPUP.heading_success_brand_popup" | translate }}</div>
  <div *ngIf="dialogData.status === constants.DONATION_STATUS_SUCCEEDED"
       class="status-text">{{ dialogData.brandName }} {{ "BRAND_POPUP.text1_brand_popup" | translate }} {{ dialogData.multiplicationFactor }}</div>
  <div *ngIf="dialogData.status === constants.DONATION_STATUS_PREMIUM"
       class="status-text">{{ dialogData.brandName }} {{ "BRAND_POPUP.text1_brand_popup" | translate }} {{ dialogData.premiumFactor }}</div>
  <div *ngIf="dialogData.status === constants.DONATION_STATUS_FAILED" [style.color]="dialogData.brandColor"
       class="status-heading">{{ "CRISIS.error_crisis" | translate }}</div>
</div>
